import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createProgram } from "../../../../services/program";

interface ProgramNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramNew(props: ProgramNewProps) {
    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            description: event.target.description.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value
        }
        createProgram(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="program-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("New program") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3 field-name" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3 field-description" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" rows={5} />
                        </Form.Group>
                        <Form.Group className="mb-3 field-date-start" controlId="date_start">
                            <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                            <Form.Control type="date" name="date_start" required />
                        </Form.Group>
                        <Form.Group className="mb-3 field-date-end" controlId="date_end">
                            <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                            <Form.Control type="date" name="date_end" required />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}